import { render, staticRenderFns } from "./individualCustomers.vue?vue&type=template&id=db4b26ae"
import script from "./individualCustomers.vue?vue&type=script&lang=js"
export * from "./individualCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports